var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Layout",
    {
      attrs: {
        clientId: _vm.clientId,
        channels: _vm.channels,
        setTitle: _vm.title,
        ads: _vm.ads,
        apiOrigin: _vm.apiOrigin
      }
    },
    [
      _c("div", { staticClass: "news-view" }, [
        _vm.article.news_type != 2
          ? _c("div", { staticClass: "article", class: _vm.setCityClass }, [
              _c("h1", { staticClass: "media-heading" }, [
                _vm._v(_vm._s(_vm.article.title))
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "last" }, [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.article.source,
                        expression: "article.source"
                      }
                    ]
                  },
                  [_vm._v("来源：" + _vm._s(_vm.article.source))]
                ),
                _vm._v(" "),
                _vm.article.author && _vm.clientId == 410600
                  ? _c("span", [_vm._v("编辑：" + _vm._s(_vm.article.author))])
                  : _vm._e(),
                _vm._v(" "),
                _vm.article.author && _vm.clientId !== 410600
                  ? _c("span", [_vm._v("作者：" + _vm._s(_vm.article.author))])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.article.released_at,
                        expression: "article.released_at"
                      }
                    ]
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.format(
                          new Date(_vm.article.released_at * 1000),
                          "YYYY-MM-DD"
                        )
                      )
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.article.views ||
                          (_vm.article.views == 0 &&
                            !(
                              _vm.clientId == 321300 || _vm.clientId == 320100
                            )),
                        expression:
                          "article.views||article.views==0&&(!(clientId==321300||clientId==320100))"
                      }
                    ],
                    staticClass: "views"
                  },
                  [_vm._v(_vm._s(_vm.article.views) + "人阅读")]
                )
              ]),
              _vm._v(" "),
              _vm.clientId == 320598
                ? _c(
                    "div",
                    {
                      staticClass: "content",
                      class: _vm.msg,
                      domProps: { innerHTML: _vm._s(_vm.article.body) }
                    },
                    [_c("span")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.clientId !== 320598
                ? _c(
                    "div",
                    {
                      staticClass: "content",
                      domProps: { innerHTML: _vm._s(_vm.article.body) }
                    },
                    [_c("span")]
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.article.news_type != 2 && _vm.article.relationsNews.length > 0
          ? _c(
              "div",
              { staticClass: "aside" },
              [
                _c("newsImgAside", {
                  attrs: {
                    title: "相关新闻",
                    type: "2",
                    clientId: _vm.clientId,
                    list: _vm.article.relationsNews
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.article.news_type == 2
          ? _c("div", { staticClass: "slide ad1" }, [
              _c("div", [
                _c("h1", { staticClass: "media-heading" }, [
                  _vm._v(_vm._s(_vm.article.title))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "last" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.article.source,
                          expression: "article.source"
                        }
                      ]
                    },
                    [_vm._v("来源：" + _vm._s(_vm.article.source))]
                  ),
                  _vm._v(" "),
                  _vm.article.author && _vm.clientId == 410600
                    ? _c("span", [
                        _vm._v("编辑：" + _vm._s(_vm.article.author))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.article.author && _vm.clientId !== 410600
                    ? _c("span", [
                        _vm._v("作者：" + _vm._s(_vm.article.author))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.article.released_at,
                          expression: "article.released_at"
                        }
                      ]
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.format(
                            new Date(_vm.article.released_at * 1000),
                            "YYYY-MM-DD"
                          )
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.article.views || _vm.article.views == 0,
                          expression: "article.views||article.views==0"
                        }
                      ]
                    },
                    [_vm._v(_vm._s(_vm.article.views) + "人阅读")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "type" }, [_vm._v("图集")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.swiperShow,
                      expression: "!swiperShow"
                    }
                  ],
                  staticStyle: { position: "absolute" },
                  attrs: { id: "imgs" }
                },
                [
                  _c("div", { staticClass: "imgs_sub" }, [
                    _c("i"),
                    _vm._v("相关图集\n                    "),
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            _vm.setShow()
                          }
                        }
                      },
                      [_vm._v("重新浏览")]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "clear" },
                    _vm._l(_vm.article.relationsNews, function(item, index) {
                      return _c("li", { staticClass: "view-imglist" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "/news/" + item.id + "?article.news_type=2"
                            }
                          },
                          [
                            _c("img", { attrs: { src: item.img_url[0] } }),
                            _vm._v(" "),
                            _c("p", [_vm._v(_vm._s(item.title))])
                          ]
                        )
                      ])
                    })
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  style: { visibility: !_vm.swiperShow ? "hidden" : "visible" }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "swiper",
                          rawName: "v-swiper:mySwiper",
                          value: _vm.swiperOption,
                          expression: "swiperOption",
                          arg: "mySwiper"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "swiper-wrapper",
                          staticStyle: { height: "670px" }
                        },
                        _vm._l(_vm.article.body, function(banner, index) {
                          return _c(
                            "div",
                            {
                              staticClass: "swiper-slide",
                              staticStyle: { height: "670px" }
                            },
                            [
                              _c("div", { staticClass: "bd" }, [
                                _c("ul", [
                                  _c("li", [
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "lazy",
                                          rawName: "v-lazy",
                                          value: {
                                            loading: _vm.lazyLoading,
                                            error: _vm.lazyLoading,
                                            src: banner.path
                                          },
                                          expression:
                                            "{\n                                            loading: lazyLoading,\n                                            error: lazyLoading,\n                                            src: banner.path\n                                          }"
                                        }
                                      ],
                                      staticClass: "view-swiper-img",
                                      attrs: {
                                        "data-src":
                                          "/public/w/img/wap/loading.png",
                                        alt: "..."
                                      }
                                    })
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "hd" }, [
                                _c("p", { staticClass: "hd-span" }, [
                                  _c("span", [_vm._v(_vm._s(index + 1))]),
                                  _vm._v(
                                    "/\n                                    "
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.article.body.length))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("ul", [
                                  _c(
                                    "li",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: banner.miaoshu,
                                          expression: "banner.miaoshu"
                                        }
                                      ],
                                      staticClass: "on"
                                    },
                                    [_vm._v(_vm._s(banner.miaoshu))]
                                  ),
                                  _vm._v(" "),
                                  _c("li", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !banner.miaoshu,
                                        expression: "!banner.miaoshu"
                                      }
                                    ],
                                    staticClass: "on"
                                  })
                                ])
                              ])
                            ]
                          )
                        })
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "swiper-button-prev",
                        attrs: { slot: "button-prev" },
                        on: {
                          click: function($event) {
                            _vm.back()
                          }
                        },
                        slot: "button-prev"
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "swiper-button-next",
                        attrs: { slot: "button-next" },
                        on: {
                          click: function($event) {
                            _vm.next()
                          }
                        },
                        slot: "button-next"
                      })
                    ]
                  )
                ]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "main clear  contents pt30 viewCopyUrl",
          attrs: { slot: "bottom" },
          slot: "bottom"
        },
        [
          _c(
            "footer",
            { staticClass: "clear", staticStyle: { "margin-top": "20px" } },
            [
              _c("p", [
                _vm._v(
                  "转载此文章须经作者同意，并请附上出处(" +
                    _vm._s(_vm.websiteName) +
                    ")及本页链接。"
                )
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("原文链接：" + _vm._s(_vm.articleUrl))])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "content-share bdsharebuttonbox bdshare-button-style0-32"
            },
            [
              _c("a", {
                staticClass: "bds-tsina pointer",
                attrs: { title: "分享到新浪微博" },
                on: {
                  click: function($event) {
                    _vm.shareToSinaWB()
                  }
                }
              }),
              _vm._v(" "),
              _c("a", {
                staticClass: "bds-weixin pointer",
                attrs: { title: "分享到微信" },
                on: {
                  mousemove: function($event) {
                    _vm.wxShareShow = true
                  },
                  mouseout: function($event) {
                    _vm.wxShareShow = false
                  }
                }
              }),
              _vm._v(" "),
              _c("a", {
                staticClass: "bds-sqq pointer",
                attrs: { title: "分享到QQ好友" },
                on: {
                  click: function($event) {
                    _vm.shareToQzone()
                  }
                }
              }),
              _vm._v(" "),
              _c("a", {
                staticClass: "bds-copy pointer",
                attrs: {
                  title: "分享到复制网址",
                  onclick:
                    "prompt('请按下 Ctrl+C 复制代码到剪贴板',document.location)",
                  value: ""
                }
              }),
              _vm._v(" "),
              _c("transition", { attrs: { name: "slide-fade" } }, [
                _vm.scrollBackShow
                  ? _c("a", {
                      staticClass: "pointer",
                      staticStyle: {
                        position: "fixed",
                        right: "90px",
                        bottom: "100px",
                        "z-index": "500"
                      },
                      attrs: { id: "top-btn" },
                      on: {
                        click: function($event) {
                          _vm.smoothscroll()
                        }
                      }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.wxShareShow,
                      expression: "wxShareShow"
                    }
                  ],
                  staticClass: "wx-QRCode"
                },
                [_c("div", { attrs: { id: "QRCode" } }), _vm._v(" "), _c("div")]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-cfcde880", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfcde880","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/web/page/news-pc/view.vue
// module id = null
// module chunks = 